import {ValueObject} from '@s-ui/domain'

export class DealerServiceValueObject extends ValueObject {
  /**
   * @constructor
   * @param {Object} param
   * @param {String} param.type
   * @param {String} param.title
   * @param {String} param.description
   * @param {Boolean} param.isIncluded
   */

  static validate({type, title, dealerServiceDealerErrorFactory}) {
    if (!type) {
      throw dealerServiceDealerErrorFactory('Dealer service needs a type')
    }
    if (!title) {
      throw dealerServiceDealerErrorFactory('Dealer service needs a title')
    }
  }
}
